import {
  getEventTickets
} from "./chunk-X4LBTNIN.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/hooks/wbk/events/tickets.ts
import { useInfiniteQuery } from "@tanstack/react-query";
var useGetEventTickets = (props) => {
  return useInfiniteQuery({
    queryKey: ["getEventTickets", props],
    queryFn: ({ pageParam = 1 }) => {
      return getEventTickets(__spreadProps(__spreadValues({}, props), { page: pageParam }));
    },
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      const meta = lastPage.meta;
      const total_pages = Math.ceil(meta.total / meta.per_page);
      return meta.current_page < total_pages ? lastPageParam + 1 : void 0;
    },
    select: (data) => {
      var _a, _b, _c, _d;
      const pages = data.pages;
      const event = (_b = (_a = pages == null ? void 0 : pages[0]) == null ? void 0 : _a.data) == null ? void 0 : _b.event;
      const meta = (_d = (_c = pages == null ? void 0 : pages.slice(-1)) == null ? void 0 : _c[0]) == null ? void 0 : _d.meta;
      return { event, meta, tickets: data.pages.flatMap((page) => page.data.event_ticket) };
    },
    initialPageParam: 1,
    staleTime: Infinity
  });
};

export {
  useGetEventTickets
};
//# sourceMappingURL=chunk-NN2QL2VA.mjs.map